'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/9/19.
                                          */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _experienceShop = require('redux/modules/experienceShop');

var experienceShopActions = _interopRequireWildcard(_experienceShop);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopPromotion = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch(experienceShopActions.getPromotions()));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.experienceShop.promotionsData
  };
}, (0, _extends3.default)({}, experienceShopActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopPromotion, _Component);

  function ExperienceShopPromotion() {
    (0, _classCallCheck3.default)(this, ExperienceShopPromotion);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopPromotion).call(this));

    _this.state = {
      orderItem: '',
      direction: '',
      filter: '',
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopPromotion, [{
    key: 'onItemClick',
    value: function onItemClick(clickItem) {
      var getPromotions = this.props.getPromotions;
      var _state = this.state;
      var direction = _state.direction;
      var filter = _state.filter;

      var currentDirection = 'ASC';
      var currentFilter = filter;
      switch (clickItem) {
        case 'default':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: 'default',
            direction: currentDirection
          });
          break;
        case 'deleted':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: 'deleted',
            direction: currentDirection
          });
          break;
        case 'newadd':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: 'newadd',
            direction: currentDirection
          });
          break;
        default:
          this.setState({
            filter: '',
            orderItem: '',
            direction: ''
          });
          currentFilter = '';
          currentDirection = '';
      }
      /*
       if (clickItem === '') {
       this.setState({
       filter: '',
       orderItem: '',
       direction: ''
       });
       currentFilter = '';
       currentDirection = '';
       } else if (clickItem === 'default') {
       if (direction === 'ASC') {
       currentDirection = 'DESC';
       }
       this.setState({
       orderItem: 'default',
       direction: currentDirection
       });
       } else if (clickItem === 'newadd') {
       if (direction === 'ASC') {
       currentDirection = 'DESC';
       }
       this.setState({
       orderItem: 'newadd',
       direction: currentDirection
       });
       } else if (clickItem === 'newadd') {
       if (direction === 'ASC') {
       currentDirection = 'DESC';
       }
       this.setState({
       orderItem: 'newadd',
       direction: currentDirection
       });
       } else if (clickItem === 'deleted') {
       if (direction === 'ASC') {
       currentDirection = 'DESC';
       }
       this.setState({
       orderItem: 'deleted',
       direction: currentDirection
       });
       } */
      if (getPromotions) {
        getPromotions(currentFilter, 0, { orderItem: clickItem, direction: currentDirection });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ExperienceShopPromotion.scss');
      var data = this.props.data;
      var orderItem = this.state.orderItem;

      var experienceShopPromotionsShow = '';
      var errorLabel = '';
      if (data) {
        var experienceShopPromotionDatas = data.experienceShopPromotionDatas;
        var experienceShopPromotionDatasError = data.experienceShopPromotionDatasError;

        if (experienceShopPromotionDatasError) {
          errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: experienceShopPromotionDatasError });
        } else {
          if (experienceShopPromotionDatas instanceof Array && experienceShopPromotionDatas.length > 0) {
            experienceShopPromotionsShow = experienceShopPromotionDatas.map(function (promotion, index) {
              return _react2.default.createElement(
                'tr',
                { key: promotion.id + index, style: { background: index % 2 === 0 ? '#f9f8f8' : '' } },
                _react2.default.createElement(
                  'td',
                  { className: styles.pt },
                  _react2.default.createElement('img', { styles: { marginTop: '12px' },
                    src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio.png' })
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.pt },
                  promotion.id
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.pt },
                  promotion.title
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.pt },
                  promotion.time
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.pt },
                  promotion.state
                )
              );
            });
          }
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'ul',
          { className: styles.jsdd },
          _react2.default.createElement(
            'li',
            { className: orderItem === '' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('');
              } },
            '全部'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'default' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('default');
              } },
            '默认'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'newadd' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('newadd');
              } },
            '新添加'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'deleted' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('deleted');
              } },
            '已删除'
          )
        ),
        _react2.default.createElement(
          'table',
          { className: styles.allTable },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '20%' }),
            _react2.default.createElement('col', { width: '30%' }),
            _react2.default.createElement('col', { width: '20%' }),
            _react2.default.createElement('col', { width: '20%' })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '选择'
              ),
              _react2.default.createElement(
                'th',
                null,
                '序号'
              ),
              _react2.default.createElement(
                'th',
                null,
                '活动标题'
              ),
              _react2.default.createElement(
                'th',
                null,
                '发布时间'
              ),
              _react2.default.createElement(
                'th',
                null,
                '活动结束'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            experienceShopPromotionsShow
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.quanxuan },
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio.png' }),
          _react2.default.createElement(
            'span',
            null,
            '全选'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.rightBtn },
          '删除'
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', { className: styles.linkb }),
        _react2.default.createElement(
          'div',
          { className: styles.sumbitBtn },
          '发布新活动'
        ),
        errorLabel
      );
    }
  }]);
  return ExperienceShopPromotion;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  getPromotions: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = ExperienceShopPromotion;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopPromotion/ExperienceShopPromotion.js
 ** module id = 1479
 ** module chunks = 0
 **/